const icon = require('vue-svgicon');
icon.register({
    'download': {
        width: 18,
        height: 18,
        viewBox: '0 0 18 18',
        data: `<path pid="0" clip-rule="evenodd" d="M9.372 12.516c.004 0 .007-.002.01-.005l3.197-3.73a.538.538 0 00-.761-.76l-2.285 2.665V2.533a.533.533 0 00-1.066 0v8.153L6.182 8.021a.539.539 0 00-.76.76l3.196 3.73c.11.11.253.156.396.152h.003a.527.527 0 00.345-.143c.003-.003.006-.003.01-.004zm-7.839 3.35h14.934a.533.533 0 00.533-.534v-4.266a.533.533 0 00-1.067 0V14.8H2.067v-3.733a.534.534 0 00-1.067 0v4.266c0 .295.239.534.533.534z"/>`,
    },
});
